module.exports = __webpack_public_path__ + "img/03_orange_talk.a8997c41.gif";